import { BufferGeometry, type Mesh } from "three"
import creaseMeshGeometryNormals from "../../fn/creaseMeshGeometryNormals"
import loadSingleModelAndMerge from "../../fn/loadSingleModelAndMerge"
import {
    Quaternius_UltimateNaturePack_Rock_Rock_1_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_2_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_3_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_4_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_5_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_6_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_7_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Moss_1_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Moss_2_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Moss_3_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Moss_4_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Moss_5_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Moss_6_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Moss_7_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Snow_1_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Snow_2_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Snow_3_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Snow_4_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Snow_5_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Snow_6_GLTF_Model,
    Quaternius_UltimateNaturePack_Rock_Rock_Snow_7_GLTF_Model,
} from "../../gltf_models.generated"

export type RockGeometrySets = {
  plain: BufferGeometry[]
  moss: BufferGeometry[]
  snow: BufferGeometry[]
}

const ROCK_SCALE = 0.6

// Cache for loaded geometries
let cachedPromise: Promise<RockGeometrySets> | undefined

function meshTest(mesh: Mesh) {
  creaseMeshGeometryNormals(mesh)
  return true
}

export default function loadAndMergeRockGeometry(): Promise<RockGeometrySets> {
  if (!cachedPromise) {
    cachedPromise = (async () => {
      const plain = await Promise.all([
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_1_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_2_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_3_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_4_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_5_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_6_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_7_GLTF_Model, ROCK_SCALE, meshTest),
      ])

      const moss = await Promise.all([
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Moss_1_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Moss_2_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Moss_3_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Moss_4_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Moss_5_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Moss_6_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Moss_7_GLTF_Model, ROCK_SCALE, meshTest),
      ])

      const snow = await Promise.all([
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Snow_1_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Snow_2_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Snow_3_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Snow_4_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Snow_5_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Snow_6_GLTF_Model, ROCK_SCALE, meshTest),
        loadSingleModelAndMerge(Quaternius_UltimateNaturePack_Rock_Rock_Snow_7_GLTF_Model, ROCK_SCALE, meshTest),
      ])

      return { plain, moss, snow }
    })()
  }

  return cachedPromise
}
